import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ArticleSharingService } from 'src/app/services/article-sharing.service';
import { ArticleService } from 'src/app/services/article.services';
import { CartService } from 'src/app/services/cart.services';
import { CAtegorieService } from 'src/app/services/categorie.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

declare var bootstrap: any;

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  scripts = [
     'assets/js/jquery.min.js',
     'assets/js/bootstrap.min.js',
     'assets/js/swiper-bundle.min.js',
     'assets/js/carousel.js',
     'assets/js/bootstrap-select.min.js',
     'assets/js/lazysize.min.js',
     'assets/js/count-down.js',
     'assets/js/wow.min.js',
     'assets/js/swiper-bundle.min.js',
     'assets/js/multiple-modal.js',
     'assets/js/main.js'
   ];
   categories: any[] = [];
   ListArticles:any[]=[];
   isInWishlist: boolean = false;
   article: any;
   quantity: number = 1;
   Categorie: any[] = [];
   ListArticlesPromo : any[] = [];
   isDesktop: boolean = true;
   currentPagePromo: number = 0;
   selectedTeinte: string = ''; // Libellé de la teinte sélectionnée
   selectedVariant: any;
   currentPageNouveautes: number = 0;
   currentPage: number = 0; // Page actuelle
 itemsPerPage: number = 4; // Nombre d'articles par page
 currentImageIndex: number = 0;
 scrollContainers: HTMLElement | null = null;
   currentIndex: number = 0;
   Marques: any[] = [];


   constructor(
     private scriptLoader: ScriptLoaderService,
     private articleservice:ArticleService,private cartService: CartService ,
     private categoriess: CAtegorieService, private cdr: ChangeDetectorRef,private router: Router,
         private route: ActivatedRoute,
         private articlesService: ArticleService,
         private wishlist : WishlistService,
         private articleSharingService: ArticleSharingService,
   ) {

   }

   ngOnInit(): void {

     this.scriptLoader.loadScripts(this.scripts);
     this.articleservice.currentArticles$.subscribe(articles => {
       this.ListArticles = articles;
       this.ListArticles.forEach((article, index) => {
         this.articleservice.getArticlesById(article.id).subscribe(detailedArticle => {
           this.ListArticles[index].details_variant = detailedArticle.details_variant;
         });
       });
       if (this.article.details_variant?.length > 0) {
         this.selectTeinte(this.article.details_variant[0]);
       }

       console.log('Articles reçus :', this.ListArticles);
     });
     this.articleservice.promoArticles$.subscribe(articles => {
       this.ListArticlesPromo = articles;
       this.ListArticlesPromo.forEach((article, index) => {
         this.articleservice.getArticlesById(article.id).subscribe(detailedArticle => {
           this.ListArticlesPromo[index].details_variant = detailedArticle.details_variant;
         });
       });
       if (this.article.details_variant?.length > 0) {
         this.selectTeinte(this.article.details_variant[0]);
       }
     });
 //this.fetchPromoArticles();
     this.checkScreenSize();
     this.loadMarques();
     this.getCategories();

     setInterval(() => {
      // this.nextImage();
     }, 3000);
   }

   @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

   scrollLeft() {
     this.scrollContainer.nativeElement.scrollLeft -= 300;
   }

   scrollRight() {
     this.scrollContainer.nativeElement.scrollLeft += 300;
   }

   ngAfterViewInit(): void {
     const marquesTrack = document.getElementById('marques-track');

     if (marquesTrack) {
       marquesTrack.addEventListener('mouseenter', () => {
         marquesTrack.style.animationPlayState = 'paused';
       });

       marquesTrack.addEventListener('mouseleave', () => {
         marquesTrack.style.animationPlayState = 'running';
       });
     }
   }

   selectTeinte(variant: any) {
     this.selectedTeinte = variant.libelle;
     this.quantity = 1;

     // Mettre à jour les propriétés de l'article directement
     this.article.libelle = variant.libelle;
     this.article.description = variant.description;
     this.article.plus_details = variant.plus_details;
     this.article.images[0].data = variant.images;
   }

   scroll(direction: 'left' | 'right') {
     const amount = 200; // Ajustez la distance de défilement
     if (this.scrollContainers) {
       this.scrollContainers.scrollBy({
         left: direction === 'left' ? -amount : amount,
         behavior: 'smooth',
       });
     }
   }
   @HostListener('window:resize', [])
   onResize() {
     this.checkScreenSize();
   }

   async checkScreenSize() {
     this.isDesktop = window.innerWidth > 768; // Ajuste selon ton besoin
     this.itemsPerPage = this.isDesktop ? 4 : 2;
   }
   changePage(direction: string, section: 'produits' | 'nouveautes' | 'promo'): void {
     const maxPages =
       section === 'produits'
         ? Math.ceil(this.ListArticles.length / this.itemsPerPage)
         : section === 'nouveautes'
         ? Math.ceil([...this.ListArticles].reverse().length / this.itemsPerPage)
         : Math.ceil(this.ListArticlesPromo.length / this.itemsPerPage); // Pour les promos

     if (section === 'produits') {
       if (direction === 'next' && this.currentPage < maxPages - 1) {
         this.currentPage++;
       } else if (direction === 'prev' && this.currentPage > 0) {
         this.currentPage--;
       }
     } else if (section === 'nouveautes') {
       if (direction === 'next' && this.currentPageNouveautes < maxPages - 1) {
         this.currentPageNouveautes++;
       } else if (direction === 'prev' && this.currentPageNouveautes > 0) {
         this.currentPageNouveautes--;
       }
     } else if (section === 'promo') {
       if (direction === 'next' && this.currentPagePromo < maxPages - 1) {
         this.currentPagePromo++;
       } else if (direction === 'prev' && this.currentPagePromo > 0) {
         this.currentPagePromo--;
       }
     }
   }

   fetchPromoArticles(): void {
     const requestPayload = {
       nbre_page: 1,
       nbre_article: 9,
       order_by: 'id',
       search: '',
       prix_min: 0,
       prix_max: 10000,
       id_marque: null,
       id_categorie: null,
       id_sous_categorie: null,
       id_sous_sous_categorie: null,
     };

     this.articleservice.getPromoArticles(requestPayload).subscribe(
       (response) => {
         this.ListArticles = response; // Liste originale
         this.ListArticlesPromo = [...this.ListArticles]; // Liste pour filtrage local
         console.log("dhddddddddddddd", this.ListArticlesPromo)
       },
       (error) => {
         console.error('Erreur lors de la récupération des articles promotionnels', error);
       }
     );
   }
   changePageN(direction: string): void {
     const maxPages = Math.ceil(this.ListArticles.length / this.itemsPerPage);

     if (direction === 'next' && this.currentPage < maxPages - 1) {
       this.currentPage++;
     } else if (direction === 'prev' && this.currentPage > 0) {
       this.currentPage--;
     }
   }
   get paginatedArticles(): any[] {
     const startIndex = this.currentPage * this.itemsPerPage;
     const endIndex = startIndex + this.itemsPerPage;
     return this.ListArticles.slice(startIndex, endIndex);
   }
   get nouveautesArticles(): any[] {
     const startIndex = this.currentPageNouveautes * this.itemsPerPage;
     const endIndex = startIndex + this.itemsPerPage;
     const articles = [...this.ListArticles].reverse().slice(startIndex, endIndex);

   return articles;
   }
     get promoArticles(): any[] {
     const startIndex = this.currentPagePromo * this.itemsPerPage;
     const endIndex = startIndex + this.itemsPerPage;
     return this.ListArticlesPromo.slice(startIndex, endIndex);
   }


   goToProduct(articleId: number, libelle: string): void {
     if (!articleId || !libelle) {
       console.error("Erreur : ID ou libellé manquant !");
       return;
     }
     const formattedLibelle = libelle.toLowerCase().replace(/ /g, '-');
     const url = `/singleproduct/${formattedLibelle}/${articleId}`;
     console.log("Navigating to:", url);
     this.router.navigate([url]);
   }



   testClick(): void {
     console.log('L\'image a été cliquée !');
   }

   navigateToBrand(marque: any): void {
     this.route.queryParams.subscribe(params => {
       // On récupère la page actuelle depuis les queryParams
       let currentPageFromParams = params['page'] ? Number(params['page']) : 1;

       // Si la marque a changé, on force currentPage à 1
       if (params['brandId'] && Number(params['brandId']) !== marque.id) {
         this.currentPage = 1;
       } else {
         this.currentPage = currentPageFromParams;
       }

       console.log("Page actuelle après navigation :", this.currentPage);
     });
     const requestBody = {
       nbre_page: this.currentPage,
       nbre_article: 12,
       order_by: 'id',
       search: '',
       prix_min: 0,
       prix_max: 2000,
       id_categorie: 0,
       id_marque: marque.id, // ✅ Filtrer par marque
       id_sous_categorie: 0,
       id_sous_sous_categorie: 0
     };

     // ✅ Active le loader

     console.log("ayoub", requestBody)
     this.articlesService.getArticlesByFilters(requestBody).subscribe(
       (response: any) => {
         console.log('Articles récupérés pour la marque:', response);
         this.articleSharingService.setArticles(response);

         // ✅ Vérifier les marques disponibles
         console.log('Marques disponibles:', this.Marques);

         // ✅ Trouver le libellé de la marque
         const selectedBrand = this.Marques.find(brand => brand.id === marque.id);
         console.log('Marque sélectionnée:', selectedBrand);

         const brandLabel = selectedBrand ? selectedBrand.libelle : '';
         console.log('Libellé de la marque:', brandLabel);

         // 🚀 Stocker le libellé
         this.articleSharingService.setSelectedCategoryLabel(brandLabel);



         // ✅ Rediriger vers la page shop
         this.router.navigate(['/marque',marque.id, brandLabel.replace(/\s+/g, '-').toLowerCase()]);

       },
       (error) => {
         console.error('Erreur lors de la récupération des articles pour la marque :', error);
         this.setFavicon(false);
       }
     );


   }

   private faviconFrames = [
     '/assets/spinner-0.svg',
     '/assets/spinner-90.svg',
     '/assets/spinner-180.svg',
     '/assets/spinner-270.svg'
   ];

   private faviconIndex = 0;
   private faviconInterval: any;

   setFavicon(isLoading: boolean): void {
       if (isLoading) {
           this.faviconInterval = setInterval(() => {
               const link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link');
               link.rel = 'icon';
               link.href = this.faviconFrames[this.faviconIndex];
               document.head.appendChild(link);

               // Passe à la frame suivante
               this.faviconIndex = (this.faviconIndex + 1) % this.faviconFrames.length;
           }, 20); // Change d'icône toutes les 200ms pour simuler l'animation
       } else {
           clearInterval(this.faviconInterval);
           const link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link');
           link.rel = 'icon';
           link.href = '/assets/img/xo.png';
           document.head.appendChild(link);
       }
   }

   formatLibelle(libelle: string): string {
     return libelle
       .toLowerCase()
       .normalize("NFD") // Supprime les accents
       .replace(/[\u0300-\u036f]/g, "") // Supprime les diacritiques
       .replace(/[^a-z0-9]+/g, '-') // Remplace les caractères non alphanumériques par "-"
       .replace(/^-+|-+$/g, ''); // Supprime les tirets en début/fin
   }

   addToCart(event: Event, product: any, quantity: number): void {
     event.preventDefault();

     if (product.details_variant?.length > 0 && !this.selectedTeinte) {

         return;
     }

     const updatedProduct = { ...product };
     let variant = null;

     if (this.selectedTeinte) {
         const selectedVariant = product.details_variant.find((v: any) => v.libelle === this.selectedTeinte);

         if (selectedVariant) {
             // Gestion spécifique des images en base64
             if (selectedVariant.images && selectedVariant.images.length > 0) {
                 // Convertir le tableau de strings en tableau d'objets {data: string}
                 updatedProduct.images = selectedVariant.images.map((img: string) => ({ data: img }));
             } else {
                 // Fallback aux images originales si pas d'images spécifiques
                 updatedProduct.images = [...product.images];
             }

             updatedProduct.libelle = `${product.libelle} - ${selectedVariant.libelle}`;
             updatedProduct.description = selectedVariant.description || product.description;
             updatedProduct.plus_details = selectedVariant.plus_details || product.plus_details;
             updatedProduct.selectedColor = selectedVariant.libelle;
             variant = selectedVariant.libelle;
         }
     }

     this.cartService.addToCart(updatedProduct, quantity, variant);
     this.loadCartItems();
     this.openCartManuellement();


 }
 openCartManuellement(): void {
   const modalElement = document.getElementById('shoppingCart');
   if (modalElement) {
     const modal = new bootstrap.Modal(modalElement);
     modal.show();
   }
 }
 cartItems: any[] = [];
 loadCartItems(): void {
   this.cartItems = this.cartService.getCartItems();
 }
   async loadMarques(){
     this.categoriess.getMarques().subscribe(
       (data) => {
         this.Marques = data;
         console.log("jihen", this.Marques)
       },
       (error) => {
         console.error('Erreur lors du chargement des marques', error);
       }
     );
   }

   navigateToShopByBrand(marque: any): void {
     this.router.navigate([`/marque/${marque.id}/${this.formatLibelle(marque.libelle)}`]);

   }


   // addToCart(product: any) {
   //   this.cartService.addToCart(product,1);


   // }
   async load(): Promise<void> {
     try {
       const requestBody = {
         nbre_page: 1,
         nbre_article: 30,
         order_by: "id",
         search: "",
       };

       console.log("🟡 Chargement des articles...");

       const res: any = await lastValueFrom(this.articleservice.getArticlesPaginated(requestBody));

       console.log("🟢 Articles reçus :", res);

       this.ListArticles = res.articles || res;

       // Vérifie que les articles sont bien récupérés
       if (this.ListArticles.length === 0) {
         console.log("❌ Aucun article trouvé");
       }
     } catch (error) {
       console.error("❌ Erreur lors du chargement des articles :", error);
     }
   }





    getCategories(): void {
     this.categoriess.getCategories().subscribe(
        response => {
          console.log('Categories:', response);
          this.Categorie = response;
          this.initCarousel();
        },
       error => {
       console.error('Could not get categories:', error);
        }
      );
    }
   initCarousel(): void {
     this.cdr.detectChanges();
   }

   totalItems: number = 0;
   totalPages: number = 0;
   pages: number[] = [];
   navigateToCategory(category: any) {
     const id = Number(category.id);
     const categoryLabel = category.libelle;

     if (isNaN(id)) {
       console.error('❌ ID de catégorie invalide:', category);
       return;
     }

     const requestBody = {
       nbre_page: 1, // On commence sur la première page
       nbre_article: 12,
       order_by: 'id',
       search: '',
       prix_min: 0,
       prix_max: 2000,
       id_categorie: id,
       id_marque: 0,
       id_sous_categorie: 0,
       id_sous_sous_categorie: 0
     };

     this.setFavicon(true);

     console.log("✅ ID:", id);
     console.log("✅ Libellé:", categoryLabel);

     // Récupérer les articles pour la catégorie
     this.articlesService.getArticlesByFilters(requestBody).subscribe(
       (response: any) => {
         // Stocker les articles et le label de la catégorie
         this.articleSharingService.setArticles(response);
         this.articleSharingService.setSelectedCategoryLabel(categoryLabel);

         // Mise à jour de la pagination
         const totalItems = response[0]?.count || 0;
         const totalPages = Math.ceil(totalItems / 12);

         // Ici, tu peux mettre à jour les variables de pagination du `ShopComponent` (si elles sont partagées)
         this.totalItems = totalItems;
         this.totalPages = totalPages;
         this.pages = Array.from({ length: totalPages }, (_, i) => i + 1); // Générer les pages dynamiquement

         // Naviguer vers la page de la boutique avec l'ID et le libellé de la catégorie
         this.setFavicon(false);

         // 🔥 Construire une URL clean
         const urlLabel = categoryLabel.replace(/\s+/g, '-').toLowerCase();
         this.router.navigate(['/shop', id, urlLabel]);
       },
       (error) => {
         console.error('Erreur lors de la récupération des articles :', error);
         this.setFavicon(false);
       }
     );
   }

   addToWishlist(product: any): void {
     this.wishlist.addToWishlist(product);

   }
 }

